import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls the page to the top whenever the pathname changes (excluding hash links).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser handle in-page anchors like #products
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
